import PropTypes from "prop-types";
import React from "react";
import { ThemeContext } from "styled-components";
import Config from "config";

export const Dolly = ({ status }) => {
  const themeContext = React.useContext(ThemeContext);
  const getColor = () => {
    if (
      status === Config.get("picking.status.PICKUP_SUCCESSFUL.value") ||
      status === Config.get("picking.status.PICKUP_OK.value")
    ) {
      return themeContext.palette.success.main;
    }

    if (status === Config.get("picking.status.PICKUP_FAILED.value")) {
      return themeContext.palette.error.main;
    }

    if (status === Config.get("picking.status.PICKUP_PARTIALLY.value")) {
      return themeContext.palette.warning.main;
    }

    return "currentColor";
  };

  return (
    <svg
      stroke={getColor()}
      fill={getColor()}
      strokeWidth="0"
      viewBox="0 0 576 512"
      height="1.5rem"
      width="1.5rem"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"></path>
    </svg>
  );
};

Dolly.propTypes = {
  status: PropTypes.string,
};
